/**
 * Gets the user's current position using browser Geolocation API
 * @param options - Optional configuration for geolocation request
 * @param options.enableHighAccuracy - Whether to use high accuracy mode
 * @param options.timeout - Maximum time to wait for position (ms)
 * @param options.maximumAge - Maximum age of cached position to accept (ms)
 * @returns Promise that resolves with GeolocationPosition or rejects with GeolocationPositionError
 */
export function getBrowserLocation(
  options?: PositionOptions
): Promise<GeolocationPosition> {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error('Geolocation is not supported by this browser'));
      return;
    }

    navigator.geolocation.getCurrentPosition(resolve, reject, options);
  });
}
